//Page types
export const FOR_YOUR_PLEASURE = 'forYourPleasure'
export const COFFEE = 'coffee'
export const CONTACT_US = 'contactUs'
export const THANK_YOU = 'thankYou'
export const GOODS = 'goods'
export const BESTSELLERS = 'bestsellers'

//Pages URL's
export const HOME_PAGE_LINK = '/'
export const FOR_YOUR_PLEASURE_LINK = 'for-your-pleasure'
export const OUR_COFFEE_LINK = 'our-coffee'
export const CONTACT_US_LINK = 'contact-us'

//Country names 
export const BRAZIL = 'Brazil'
export const KENYA = 'Kenya'
export const COLUMBIA = 'Columbia'
export const ALL = 'All'

//Form labels
export const EMAIL = 'E-mail'
export const NAME = 'Name'
export const PHONE = 'Phone'

//DB URL's
export const API_BASE = 'https://react-coffee-shop-app-ee3d5.firebaseio.com'
export const CONTACTS_DB_URL = '/contacts'